module.exports = __webpack_public_path__ + "img/coverage_circles.38940153.png";